const INTERACTIVE_SELECTOR = [
   'button',
   'input',
   'textarea',
   'select',
   'a[href]',
   '[role="button"]',
   '[role="link"]',
   '[contenteditable="true"]',
   '[tabindex]:not([tabindex="-1"])',
].join(', ');

export function isInteractiveElement(target: EventTarget | null): boolean {
   return target instanceof HTMLElement && target.closest(INTERACTIVE_SELECTOR) != null;
}
